"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(require("prop-types-exact/build/helpers/isPlainObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _isPlainObject["default"];
exports["default"] = _default;
//# sourceMappingURL=isPlainObject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-prop-types/build/helpers/isPlainObject.js
// module id = 286
// module chunks = 0